import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },

  //ADMINISTRADOR
  {
    path: '/dashboard-admin',
    name: 'dashboard-admin',
    component: () => import('../views/admin/Dashboard.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },

  {
    path: '/users-admin',
    name: 'users-admin',
    component: () => import('../views/admin/Users.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },
  {
    path: '/user-profile/:id',
    name: 'user-profile',
    component: () => import('../views/admin/UserProfile.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },
  {
    path: '/payments-admin',
    name: 'payments-admin',
    component: () => import('../views/admin/Payments.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },

  {
    path: '/messages-admin',
    name: 'messages-admin',
    component: () => import('../views/admin/Messages.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },

  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/Admin.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  },

  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/admin/Settings.vue'),
    meta: {
      requiresAuth: true,
      type: 'admin'
    }
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
